import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SeoState } from './seo.state';

const selectSeoState = createFeatureSelector<SeoState>('seo');

export const getHomeUrls = createSelector(selectSeoState, (state: SeoState) =>
    state?.homeUrls);

export const getLastSectionTranslated = createSelector(selectSeoState, (state: SeoState) =>
    state?.lastSectionTranslated);
